import styled from 'styled-components'

interface IFormSectionStyledProps {}

export const FormSectionStyled = styled.div<IFormSectionStyledProps>`
  & + & {
    margin-top: ${(props) => props.theme.typography.pxToRem(16)};
  }
`
